import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import {OverlayTrigger, Tooltip} from "react-bootstrap-v5";
import Moment from "react-moment";

interface Props {
    attachmentActivity: any
}

const AttachmentsViewActivityModal: React.FC<Props> = (props) => {
    const { attachmentActivity } = props

    console.log("Attachment Activity")
    console.log(attachmentActivity)
    
    return (
        <>
            <div className='modal fade' id='attachment_view_activity_modal'>
                <div className='modal-dialog modal-dialog-centered'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title'>Activity</h5>

                            <div
                                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                                data-bs-dismiss='modal'
                                aria-label='Close'
                            >
                                <span className='svg-icon svg-icon-2x'></span>
                            </div>
                        </div>

                        <div className='modal-body'>
                           <table style={{borderTop:'2px solid black'}}>
                                <tbody>
                                    {attachmentActivity && attachmentActivity.map((activity: any) => {
                                        return (
                                            <tr key={activity.id}>
                                                <td className="pe-2 py-2" style={{borderBottom:'2px solid black'}}>
                                                    {activity.fileProvider === "azureStorage" && <span className='badge badge-light-info'>Azure</span>}
                                                    {activity.fileProvider === "mFiles" && <span className='badge badge-light-success'>M-Files</span>}
                                                </td>
                                                <td className="pe-2 py-2" style={{borderBottom:'2px solid black'}}>
                                                    {activity.reason}<br />
                                                    <small><Moment format="YYYY-MM-DD HH:mm:ss">{activity.created}</Moment></small>
                                                </td>
                                                <td className="pe-2 py-2" style={{borderBottom:'2px solid black'}}>
                                                    {activity.operationSuccessful && (
                                                        <OverlayTrigger placement='bottom' overlay={<Tooltip id={`success-${activity.id}`}>Sync successful</Tooltip>}>
                                                            <i className="bi bi-check2-circle me-2" style={{ color: "green" }}></i>
                                                        </OverlayTrigger>
                                                    )}

                                                    {!activity.operationSuccessful && (
                                                        <OverlayTrigger placement='bottom' overlay={<Tooltip id={`fail-${activity.id}`}>{activity.errorMessage}</Tooltip>}>
                                                            <i className="bi bi-slash-circle-fill me-2" style={{ color: "red" }}></i>
                                                        </OverlayTrigger>
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                           </table>
                        </div>
                        <div className='modal-footer'>
                            <button
                                type='button'
                                className='btn btn-light'
                                data-bs-dismiss='modal'
                                id='attachment_view_modal_dismiss'
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AttachmentsViewActivityModal
